import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "How often should fire extinguishers be serviced in Nigeria?",
            answer: "According to the Federal Fire Service and international safety standards (NFPA 10), fire extinguishers should undergo a basic service every 12 months. In high-risk environments like factories or petrol stations, a monthly visual inspection is recommended to ensure pressure levels are optimal."
        },
        {
            question: "Do you provide fire safety certification for corporate offices?",
            answer: "Yes. After installation or a successful safety audit and staff training, we issue a Certificate of Fire Safety Compliance. This document is often required by insurance companies and regulatory bodies like the State Fire Service to prove your premises are protected."
        },
        {
            question: "Which fire extinguisher is best for a server room or kitchen?",
            answer: "For server rooms and electrical hubs, a CO2 (Carbon Dioxide) extinguisher is best as it leaves no residue and won't damage electronics. For kitchens, a Wet Chemical extinguisher is preferred for fat fires, though a Fire Blanket is also a mandatory cost-effective tool for residential kitchens."
        },
        {
            question: "Is fire safety training mandatory for factory workers?",
            answer: "Yes, under the Nigerian Occupational Health and Safety laws, employers are required to provide adequate safety training. Our 'Fire Warden' training covers evacuation drills, equipment handling, and fire prevention, ensuring your factory meets legal requirements."
        },
        {
            question: "Can I refill an extinguisher, or must I buy a new one after use?",
            answer: "If the cylinder is in good condition and hasn't expired (usually a 5-10 year lifespan), it can be refilled. We provide professional refilling services where we discharge, clean, refill, and repressurize your units at a fraction of the cost of a new one."
        },
        {
            question: "Do you offer on-site safety lectures for residential estates?",
            answer: "Absolutely. We conduct community safety workshops for residential estates to teach families and domestic staff how to react during a fire. We also offer group procurement discounts for estate associations looking to equip all homes with safety kits."
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="py-20 bg-slate-50" id="faq">
            <div className="max-w-4xl mx-auto px-4">
                <div className="text-center mb-12">
                    <div className="flex justify-center mb-4">
                        <span className="bg-red-100 text-red-600 p-3 rounded-full">
                            <HelpCircle className="w-8 h-8" />
                        </span>
                    </div>
                    <h2 className="text-3xl font-bold text-slate-900 mb-4">Frequently Asked Questions</h2>
                    <p className="text-slate-600">Everything you need to know about fire safety and compliance in Nigeria.</p>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="bg-white border border-slate-200 rounded-xl overflow-hidden transition-all duration-300"
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-colors"
                            >
                                <span className="font-bold text-slate-800 pr-4">{faq.question}</span>
                                {activeIndex === index ? (
                                    <ChevronUp className="w-5 h-5 text-red-600 flex-shrink-0" />
                                ) : (
                                    <ChevronDown className="w-5 h-5 text-slate-400 flex-shrink-0" />
                                )}
                            </button>

                            <div
                                className={`overflow-hidden transition-all duration-300 ${activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <div className="p-5 pt-0 text-slate-600 leading-relaxed border-t border-slate-50">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* SEO/GEO Text Block (Hidden or subtle) */}
                <div className="mt-12 text-center">
                    <p className="text-sm text-slate-400 italic">
                        Need a specific safety plan for your facility? <a href="#contact" className="text-red-600 font-bold underline">Contact our lead safety consultant today.</a>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default FAQ;